function Eq() {
  return (
    <>
      <section className="flex flex-col lg:flex-row items-start justify-start lg:items-center lg:justify-between gap-6 lg:gap-12">
        <div className="w-full flex flex-col items-start justify-center gap-2 text-left p-6 lg:px-24 lg:py-12">
          <h2 className="uppercase color-yellow text-xl">Sprzęt</h2>
          <h3 className="text-3xl lg:text-5xl color-green">
            Sprzęt, który <span className="color-yellow">sprawdzi się</span>
            <br></br>w każdych warunkach
          </h3>
          <p className="text-gray-600">
            Jako fachowcy dysponujemy specjalistycznym sprzętem, a nasze
            nowoczesne podejście, znajomość aktualnych trendów, ale i kierowanie
            się tradycyjnymi metodami, pozwala nam tworzyć ogrody i zieleńce na
            pierwszorzędnym poziomie. Indywidualne podejście do każdego wyzwania
            daje nam możliwość tworzenia dla Ciebie, Twoich bliskich czy firmy
            najlepszych rozwiązań, które przerosną Wasze oczekiwania!
          </p>
          <span className="bg-green h-[1px] mt-6 w-full"></span>
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-2">
            <div className="flex flex-col items-center justify-center">
              {" "}
              <img
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/tools-1.png"
                alt="Sprzęt ogrodniczy Drzewus - narzędzie nr 1"
              />
            </div>
            <div className="flex flex-col items-center justify-center">
              {" "}
              <img
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/tools-2.png"
                alt="Sprzęt ogrodniczy Drzewus - narzędzie nr 2"
              />
            </div>
            <div className="flex flex-col items-center justify-center">
              {" "}
              <img
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/tools-3.png"
                alt="Sprzęt ogrodniczy Drzewus - narzędzie nr 3"
              />
            </div>
            <div className="flex flex-col items-center justify-center">
              {" "}
              <img
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/stihl-logo.png"
                alt="Logo Stihl - partner Drzewus"
              />
            </div>
            <div className="flex flex-col items-center justify-center">
              {" "}
              <img
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/fiskars-logo-1.jpg"
                alt="Logo Fiskars - partner Drzewus"
              />
            </div>
          </div>
        </div>
        <div className="w-full flex flex-row items-center justify-end">
          <img
            src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/about-eq.png"
            alt="Sprzęt ogrodniczy Drzewus - maszyny do pracy"
          />
        </div>
      </section>
    </>
  );
}

export default Eq;
